'use strict';
const React = require('react');
const BaseComponent = require('../../../../../views/shared/base');

class MoqComponent extends BaseComponent {
    render() {
        return '';
    }
}

module.exports = MoqComponent;